import axios from 'axios';
import { apiClientPowerBI } from '../ApiClient';
import { redirectToLoginPage } from '../../../helper';

const PowerBIService = {
    getPowerBi: async (groupId, reportId, instance) => {
        try {
            return (await apiClientPowerBI.get(`powerbi/token/${groupId}/${reportId}`)).data;
        } catch (error) {
            console.error('Error fetching users:', error);
            if (error.response && error.response.status === 401) {
                if(instance){
                    redirectToLoginPage(instance);
                }
            }
            return null;
        }
    },
};

export default PowerBIService;
